import Vue from 'vue';

class Tcp {
  constructor(options = {}) {
    this.options = options;
    this.registeredEvents = new Set();
    this.eventBus = new Vue();
  }

  install() {
    this.init();
    Vue.prototype.$tcp = this;
  }

  init() {
    // 创建全局事件处理函数
    window.handleAppEvent = (eventName, eventData) => {
      this.handleH5EmitEvent(eventName, eventData);
    };
  }

  on(eventName, eventFunction) {
    if (!this.registeredEvents.has(eventName)) {
      this.registeredEvents.add(eventName);
    }
    this.eventBus.$on(eventName, eventFunction);
  }

  off(eventName, eventFunction) {
    this.eventBus.$off(eventName, eventFunction);
  }

  handleH5EmitEvent(eventName, eventData) {
    if (this.registeredEvents.has(eventName)) {
      this.eventBus.$emit(eventName, eventData);
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Event ${eventName} is not registered!`);
    }
  }
}

export default Tcp;
